import React from 'react';
import styled from 'styled-components';

type Direction = 'up' | 'down' | 'flat';

interface SparklineProps {
  /** SVG path string (e.g. "M0,18 L13,15 L26,17 ...") */
  path: string;
  /** Color direction — maps to theme colors */
  direction?: Direction;
  /** Custom stroke color (overrides direction) */
  color?: string;
  /** Width in px (default 80) */
  width?: number;
  /** Height in px (default 24) */
  height?: number;
  /** Stroke width (default 1.5) */
  strokeWidth?: number;
  className?: string;
}

export const Sparkline: React.FC<SparklineProps> = ({
  path,
  direction = 'up',
  color,
  width = 80,
  height = 24,
  strokeWidth = 1.5,
  className
}) => {
  const strokeColor =
    color ??
    (direction === 'down'
      ? 'var(--crimson)'
      : direction === 'flat'
        ? 'var(--ink-faint)'
        : 'var(--olive)');

  return (
    <Svg
      viewBox={`0 0 ${width} ${height}`}
      $width={width}
      $height={height}
      className={className}
    >
      <path
        d={path}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

const Svg = styled.svg<{ $width: number; $height: number }>`
  width: ${({ $width }) => $width}px;
  height: ${({ $height }) => $height}px;
  flex-shrink: 0;
`;
